import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BrainCircuit } from "lucide-react";

const links = [
  { label: "Señales", href: "#senales" },
  { label: "Facilitadora", href: "#facilitadora" },
  { label: "Inversión", href: "#inversion" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    window.__lenis?.scrollTo(href, { offset: -20 });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "glass border-b border-white/10" : "border-b border-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <img src="/assets/logo-meli.webp" alt="Meli Market Minds" className="h-9 w-auto mix-blend-screen" />
          <span className="hidden font-display text-xs font-extrabold uppercase tracking-[0.25em] text-lilac/70 sm:block">
            · Método Cerebro
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs font-medium uppercase tracking-[0.2em] text-lilac transition-colors duration-300 hover:text-magenta"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <span
          data-testid="nav-cta-inscribirme"
          className="cursor-not-allowed border border-orange-500/60 px-5 py-2 text-xs font-bold uppercase tracking-[0.2em] text-orange-400"
        >
          Sold out
        </span>
      </div>
    </motion.header>
  );
};

export default Nav;
